export const INPUT_DIALOG_CHOICE = {
    Submit: 'SUBMIT',
    Cancel: 'CANCEL',
};

